import React, { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { strings } from "../../Translations/strings";
import "../Auth.scss";
import NewPasswordForm from "./NewPasswordForm";

const NewPassword = () => {
  const { token } = useParams();
  const navigation = useNavigate();
  const [isSuccess, setIsSuccess] = useState(false);

  // If no token, redirect to login
  if (!token) {
    navigation("/login");
    return null;
  }

  const handleSuccessChange = (success) => {
    setIsSuccess(success);
  };

  return (
    <div className="d-flex justify-content-center align-items-center login-container">
      <div className="nav-logo">
        <div className="empty-container"></div>
        <Link to="/">
          <img
            className="logo"
            src={require("../../Assets/logo.svg").default}
            alt="logo"
          />
        </Link>
        <div className="empty-container"></div>
      </div>
      <div className="contet-wrapper">
        <div className="form-container">
          {!isSuccess && (
            <p className="header-title">{strings.new_password_title}</p>
          )}
          <NewPasswordForm token={token} onSuccessChange={handleSuccessChange} />
        </div>
      </div>
    </div>
  );
};

export default NewPassword;
